const activityEventStatus = {
    NEW : 0,

    VIEWED : 1

};

angular.module('gw-um-j2js')
    .constant('activityEventStatus', activityEventStatus);